import { render } from "./ViewAirtimeLogs.vue?vue&type=template&id=f1bfc0ba&scoped=true"
import script from "./ViewAirtimeLogs.vue?vue&type=script&lang=js"
export * from "./ViewAirtimeLogs.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=f1bfc0ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bfc0ba"]])

export default __exports__